<app-menu></app-menu>

<div style="background-color: #f8f9fa;">
    <!-- Hero Section -->
    <div class="fundo uk-light">
        <div class="uk-container uk-text-center">
            <h1 class="hero-standard-title" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">
                E-mail Corporativo: <b>Sua marca</b>,<br> sua <b>credibilidade</b>
            </h1>
            <p class="uk-margin-small-top uk-width-1-1 uk-margin-auto uk-text-nowrap"
                style="font-size: 1.2rem; opacity: 0.9;"
                uk-scrollspy="cls: uk-animation-slide-bottom-small; delay: 300">
                Fortaleça a identidade da sua empresa com endereços de e-mail personalizados e ferramentas de
                colaboração de última geração.
            </p>
        </div>
    </div>
</div>

<!-- Features Section -->
<div class="uk-padding-small uk-section-muted" style="padding-bottom: 0;">
    <div class="uk-container">
        <!-- Powered By Section -->
        <div class="uk-text-center uk-margin-large-top uk-margin-large-bottom" 
            uk-scrollspy="cls: uk-animation-fade; delay: 200"
            style="display: flex; align-items: center; justify-content: center; gap: 10px;">
            <span style="font-size: 1.1rem; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; color: #666;">powered by</span>
            <img src="img/webmail-logo.svg" alt="Webmail" style="height: 32px; width: auto; display: block;">
        </div>

        <div class="email-corp-card uk-position-relative" uk-scrollspy="cls: uk-animation-scale-up; delay: 100">
            <!-- Badge Promoção Mobile -->
            <div class="uk-badge uk-hidden@m uk-margin-bottom"
                style="display: flex; align-items: center; justify-content: center; background-color: #d32f2f; color: white; font-size: 1.05rem; padding: 12px 24px; font-weight: 900; width: fit-content; margin: 0 auto; box-shadow: 0 6px 20px rgba(211, 47, 47, 0.6), 0 0 0 2px rgba(255,255,255,0.8); letter-spacing: 0.5px; border-radius: 50px;">
                <span uk-icon="icon: tag; ratio: 1" class="uk-margin-small-right"></span> PROMOÇÃO ESPECIAL
            </div>

            <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle" uk-grid>
                <!-- Lado Esquerdo: Título, Vídeo e Branding -->
                <div class="uk-width-auto@m uk-flex uk-flex-center uk-flex-middle">
                    <div class="video-container uk-margin-medium-bottom"
                        style="width: 100%; max-width: 280px; border-radius: 12px; overflow: hidden; box-shadow: 0 8px 25px rgba(0,0,0,0.1); margin: 0 auto;">
                        <video #videoPlayer autoplay loop muted playsinline preload="auto"
                            style="width: 100%; height: auto; display: block; object-fit: cover; pointer-events: none; outline: none;">
                            <source src="vid/emailcorp.mp4" type="video/mp4">
                        </video>
                    </div>
                </div>

                <!-- Lado Direito: Descrição -->
                <div class="uk-width-expand@m">
                    <div class="description-box">
                        <div class="uk-badge uk-margin-bottom uk-visible@m pulse-animation"
                            style="display: flex; align-items: center; justify-content: center; background-color: #d32f2f; color: white; font-size: 1.1rem; height: 50px; padding: 0 35px; margin: 35px 0 15px 0; width: fit-content; font-weight: 900; box-shadow: 0 6px 20px rgba(211, 47, 47, 0.5); letter-spacing: 1px; border-radius: 50px; text-transform: uppercase;">
                            <span uk-icon="icon: tag; ratio: 1.2" class="uk-margin-small-right"></span> PROMOÇÃO
                            ESPECIAL
                        </div>
                        <h4 class="uk-text-bold highlight-text"
                            style="font-weight: 800; letter-spacing: 1px; font-size: 1.3rem;">Sua marca, seu e-mail.
                        </h4>
                        <p class="uk-text-lead"
                            style="color: #111; line-height: 1.3; font-size: 1.9rem; font-weight: 800; margin-bottom: 15px;">
                            Garanta maior profissionalismo para o seu negócio com e-mails personalizados e altamente
                            seguros.
                        </p>
                        <p style="color: #666; font-size: 1.1rem; font-weight: 400; line-height: 1.6;">
                            Nossa solução oferece sincronização em tempo real, proteção avançada contra spam e uma
                            interface intuitiva para gerenciar sua comunicação corporativa de qualquer lugar.
                        </p>
                        <ul class="uk-list uk-text-left" style="flex-grow: 1; color: #444; font-size: 1.05rem;">
                            <li><span uk-icon="users" class="uk-margin-small-right highlight-text"></span> <b>Contas de
                                    usuário:</b> Ilimitado</li>
                            <li><span uk-icon="list" class="uk-margin-small-right highlight-text"></span> <b>Listas de
                                    Distribuição:</b> 1</li>
                            <li><span uk-icon="forward" class="uk-margin-small-right highlight-text"></span>
                                <b>Encaminhadores:</b> Ilimitado
                            </li>
                            <li><span uk-icon="refresh" class="uk-margin-small-right highlight-text"></span>
                                <b>Backups:</b> Semanais
                            </li>
                            <li><span uk-icon="mail" class="uk-margin-small-right highlight-text"></span> <b>Painel:</b>
                                Webmail Premium</li>
                            <li><span uk-icon="receiver" class="uk-margin-small-right highlight-text"></span>
                                <b>Integração:</b> IMAP / SMTP (Outlook, Gmail, etc)
                            </li>
                        </ul>
                        <div class="uk-margin-medium-top uk-flex uk-flex-left">
                            <a href="https://api.whatsapp.com/send/?phone=244937754502&text=Olá, estou interessado no plano de E-mail Corporativo profissional."
                                target="_blank" class="uk-button btn-buy" style="width: 250px; margin-top: 0;">
                                <span uk-icon="cart" class="uk-margin-small-right"></span> ADQUIRIR AGORA
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Pricing Section -->
<div id="planos" class="uk-padding uk-section-muted">
    <div class="uk-container">
        <div class="uk-text-center uk-margin-large-bottom" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">
            <h2 class="uk-text-bold highlight-text" style="font-size: 2.2rem;">Escolha o Plano Ideal</h2>
            <p class="uk-text-large" style="color: #666;">Soluções de e-mail sob medida para o tamanho da sua empresa.
            </p>
        </div>

        <div class="uk-grid uk-grid-match uk-child-width-1-3@m uk-child-width-1-1@s" uk-grid
            uk-scrollspy="cls: uk-animation-slide-bottom-small; target: > div; delay: 200">
            <!-- Plano Básico -->
            <div>
                <div class="card-plano">
                    <h3 class="uk-text-bold highlight-text uk-margin-remove">E-mail BÁSICO <span
                            style="font-size: 1.2rem; font-weight: normal; color: #666;">(10GB)</span></h3>
                    <div class="uk-margin-small-top uk-margin-small-bottom">
                        <h2 class="uk-margin-remove uk-text-bold" style="font-size: 2.5rem; color: #333;">250,00
                            Kz<small style="font-size: 1rem; font-weight: normal; color: #666;"> / Mensal</small></h2>
                        <p class="uk-text-small uk-text-muted uk-margin-remove-top">(Facturação anual)</p>
                    </div>

                    <ul class="uk-list uk-list-muted uk-text-left uk-margin-small-top" style="flex-grow: 1;">
                        <li><span uk-icon="mail" class="uk-margin-small-right highlight-text"></span>
                            email&#64;seu-domínio.com</li>
                        <li><span uk-icon="rss" class="uk-margin-small-right highlight-text"></span> Até <b>1.800</b>
                            e-mails/dia</li>
                        <li><span uk-icon="world" class="uk-margin-small-right highlight-text"></span> Webmail
                            (Roundcube)</li>
                        <li><span uk-icon="receiver" class="uk-margin-small-right highlight-text"></span> Acesso móvel e
                            desktop</li>
                    </ul>
                    <small class="uk-text-muted uk-text-left"
                        style="display: block; width: 100%; margin-bottom: 15px;">Nota: Preço por caixa de
                        e-mail.</small>
                    <a target="_blank"
                        href="https://wa.me/244937754502/?text=Olá, estou interessado no plano de E-mail Corporativo Fluxo Básico (10GB)."
                        class="uk-button btn-buy uk-margin-top">
                        <span uk-icon="cart" class="uk-margin-small-right"></span> Comprar Agora
                    </a>
                </div>
            </div>

            <!-- Plano Médio -->
            <div>
                <div class="card-plano card-plano-premium">
                    <div class="uk-badge uk-position-top-right uk-margin-right uk-margin-top popular-badge">MAIS POPULAR
                    </div>
                    <h3 class="uk-text-bold uk-margin-remove">E-mail PLUS <span
                            style="font-size: 1.2rem; font-weight: normal; color: rgba(255,255,255,0.8);">(50GB)</span>
                    </h3>
                    <div class="uk-margin-small-top uk-margin-small-bottom">
                        <h2 class="uk-margin-remove uk-text-bold" style="font-size: 2.5rem;">350,00 Kz<small
                                style="font-size: 1rem; font-weight: normal; opacity: 0.9;"> / Mensal</small></h2>
                        <p class="uk-text-small uk-margin-remove-top"
                            style="color: rgba(255, 255, 255, 0.8); margin-bottom: 0;">
                         (Facturação anual)
                        </p>
                    </div>

                    <ul class="uk-list uk-text-left uk-margin-small-top" style="flex-grow: 1;">
                        <li><span uk-icon="mail" class="uk-margin-small-right"></span> email&#64;seu-domínio.com</li>
                        <li><span uk-icon="rss" class="uk-margin-small-right"></span> Até <b>2.800</b> e-mails/dia</li>
                        <li><span uk-icon="world" class="uk-margin-small-right"></span> Webmail (Roundcube)</li>
                        <li><span uk-icon="receiver" class="uk-margin-small-right"></span> Acesso móvel e desktop</li>
                    </ul>
                    <small
                        style="color: rgba(255, 255, 255, 0.8); display: block; width: 100%; text-align: left; margin-bottom: 15px;">Nota:
                        Preço por caixa de e-mail.</small>
                    <a target="_blank"
                        href="https://wa.me/244937754502/?text=Olá, estou interessado no plano de E-mail Corporativo Fluxo Médio (50GB) com desconto."
                        class="uk-button btn-buy btn-buy-inverse uk-margin-top">
                        <span uk-icon="cart" class="uk-margin-small-right"></span> Comprar Agora
                    </a>
                </div>
            </div>

            <!-- Plano Premium -->
            <div>
                <div class="card-plano">
                    <h3 class="uk-text-bold highlight-text uk-margin-remove">E-mail PREMIUM <span
                            style="font-size: 1.2rem; font-weight: normal; color: #666;">(100GB)</span></h3>
                    <div class="uk-margin-small-top uk-margin-small-bottom">
                        <h2 class="uk-margin-remove uk-text-bold" style="font-size: 2.5rem; color: #333;">550,00
                            Kz<small style="font-size: 1rem; font-weight: normal; color: #666;"> / Mensal</small></h2>
                        <p class="uk-text-small uk-text-muted uk-margin-remove-top">(Facturação anual)</p>
                    </div>

                    <ul class="uk-list uk-list-muted uk-text-left uk-margin-small-top" style="flex-grow: 1;">
                        <li><span uk-icon="mail" class="uk-margin-small-right highlight-text"></span>
                            email&#64;seu-domínio.com</li>
                        <li><span uk-icon="rss" class="uk-margin-small-right highlight-text"></span> Até <b>4.800</b>
                            e-mails/dia</li>
                        <li><span uk-icon="world" class="uk-margin-small-right highlight-text"></span> Webmail
                            (Roundcube)</li>
                        <li><span uk-icon="receiver" class="uk-margin-small-right highlight-text"></span> Acesso móvel e
                            desktop</li>
                    </ul>
                    <small class="uk-text-muted uk-text-left"
                        style="display: block; width: 100%; margin-bottom: 15px;">Nota: Preço por caixa de
                        e-mail.</small>
                    <a target="_blank"
                        href="https://wa.me/244937754502/?text=Olá, estou interessado no plano de E-mail Corporativo Fluxo Premium (100GB)."
                        class="uk-button btn-buy uk-margin-top">
                        <span uk-icon="cart" class="uk-margin-small-right"></span> Comprar Agora
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>




<!-- Final CTA Section -->
<div class="uk-section uk-section-default cta-section">
    <div class="uk-container">
        <div class="premium-cta-box uk-text-center" uk-scrollspy="cls: uk-animation-scale-up; delay: 100">
            <!-- Animated Background Elements -->
            <div class="cta-glow"></div>
            <div class="light-particles">
                <div class="particle p1"></div>
                <div class="particle p2"></div>
                <div class="particle p3"></div>
                <div class="particle p4"></div>
                <div class="particle p5"></div>
                <div class="particle p6"></div>
                <div class="particle p7"></div>
                <div class="particle p8"></div>
                <div class="particle p9"></div>
                <div class="particle p10"></div>
            </div>

            <div class="cta-content" uk-scrollspy="cls: uk-animation-slide-bottom-small; delay: 300">
                <h2>Comunicação Profissional e Segura</h2>
                <p>Ideal para empresas que buscam credibilidade e organização. O E-mail Corporativo é a ferramenta
                    definitiva para centralizar e elevar o seu negócio.</p>
                <a href="https://wa.me/244937754502/?text=Olá, desejo saber mais sobre o E-mail Corporativo profissional."
                    target="_blank" class="uk-button cta-btn-premium">
                    <i class="fa-solid fa-headset uk-margin-small-right"></i> Fale com Especialistas
                </a>
            </div>
        </div>
    </div>
</div>

<app-rodape></app-rodape>